import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"

const Completionist = () => <span>Our latest release, Dystater was available from the 7th of June, 2023, get it now in the Products tab.</span>;

const render = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <Completionist />;
  } else {
    return <span>{days} days : {hours} hours : {minutes} minutes : {seconds} seconds left</span>;
  }
};

const HomeWelcome = () => (
  <List divided relaxed>
    <Header as="h3" textAlign="center">WELCOME AGAIN!</Header>
    <Header color="brown" as="h3" textAlign="center">Our latest LAUNCH: <Countdown date={new Date(2020, 12, 31, 12)} renderer={render} /></Header>


    <Header as="h4" textAlign="center">Phykraun is a technology company that is behind apps like Bazaar, Dystater and Code Dialer.
    We aim to give our consumers the best technologies in the world and we support the best
technologies in the world.</Header>

  </List>
)

export default HomeWelcome
